var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapDirectionsinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64v64H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "m9.31 33.728-.628.778-1.558-1.254.628-.779q1.479-1.837 3.13-2.947l.831-.557 1.115 1.66-.83.558q-1.391.93-2.689 2.54zm6.042-3.71-.993.117-.235-1.986.993-.118c1.418-.167 2.889.002 4.404.5l.95.312-.625 1.9-.95-.312q-1.869-.613-3.544-.414zm10.092 2.177-.85-.527 1.054-1.7.85.527q1.767 1.096 3.396 1.67l.943.333-.666 1.886-.943-.333q-1.841-.649-3.784-1.856m8.18 3.065-.999.016-.031-2 1-.016a7.9 7.9 0 0 0 3.455-.845l.895-.446.892 1.79-.895.446a9.9 9.9 0 0 1-4.316 1.055z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M23 5v43.069L5 59V15.937zm36 0v43.069L41 59V15.937zM23 5v43.069L41 59V15.937z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M50 35s5-5.814 5-9.37c0-2.557-2.239-4.63-5-4.63s-5 2.073-5 4.63c0 3.556 5 9.37 5 9.37z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M50 27a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}))));
export default SvgMapDirectionsinline;